<template>
  <form-layout
    title="Reject approval"
    save-label="Reject"
    discard-label="Cancel"
    has-changes
    :is-saving="isRejecting"
    @on-dismiss="dismiss"
    @on-save="onSubmit"
    @on-discard="dismiss"
  >
    <vs-form>
      <vs-wrapper>
        <vs-text-input v-model="rejectionMessage" multiline label="Reason" />
      </vs-wrapper>
    </vs-form>

    <template #snack-bar-wrapper>
      <vs-snackbar v-model="isSnackbarVisible" type="error" sticky>
        Failed to reject the job.
      </vs-snackbar>
    </template>
  </form-layout>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import FormLayout from '@/components/common/FormLayout.vue'
import VsSnackbar from '@/components/vision/VsSnackbar.vue'
import VsForm from '@/components/vision/VsForm.vue'
import { rejectJobApprovalMutation } from '@/api/jobs'
import { useJobBottomSheetStatesStore } from '@/components/jobs/jobBottomSheetStatesStore'

interface Props {
  jobId: string
}

const props = defineProps<Props>()

const jobBottomSheetStatesStore = useJobBottomSheetStatesStore()

const emit = defineEmits<{
  (e: 'approval-rejected-success')
}>()

const isRejecting = ref(false)
const rejectionMessage = ref('')
const isSnackbarVisible = ref(false)

const { mutateAsync: rejectApproval } = rejectJobApprovalMutation()

async function onSubmit() {
  isRejecting.value = true

  try {
    await rejectApproval({
      id: props.jobId,
      rejectionMessage: rejectionMessage.value,
    })
    emit('approval-rejected-success')
    dismiss()
  } catch {
    isSnackbarVisible.value = true
  } finally {
    isRejecting.value = false
  }
}

function dismiss() {
  jobBottomSheetStatesStore.setJobBottomSheetStates({
    isRejectingApprovalBottomSheetVisible: false,
  })
}
</script>

<style scoped></style>
